// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloudSyncRoundedIcon from '@mui/icons-material/CloudSyncRounded';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import HandymanRoundedIcon from '@mui/icons-material/HandymanRounded';

// material ui
import { alpha, Chip } from '@mui/material';

export default function StateChip({ state, size = 'small' }) {
  const { t } = useTranslation('energyxplorer-initiatives-tab');
  const config = {
    Done: {
      color: 'success',
      icon: <CheckCircleRoundedIcon color="success" />,
    },
    Active: {
      color: 'info',
      icon: <AutorenewRoundedIcon color="info" />,
    },
    Created: {
      color: 'warning',
      icon: null,
    },
    Initialized: {
      color: 'primary',
      icon: <CloudSyncRoundedIcon color="primary" />,
    },
    Archived: {
      color: 'default',
      icon: <FolderRoundedIcon color="disabled" />,
    },
    RequiresActions: {
      color: 'error',
      icon: <HandymanRoundedIcon color="error" />,
    },
  };

  const { color, icon } = config[state] || {
    color: 'default',
    icon: null,
  };

  return (
    <Chip
      size={size}
      variant="filled"
      icon={icon}
      label={t(`common.${state.toLowerCase()}`) || 'Kræver handling'}
      sx={(theme) => ({
        backgroundColor:
          color !== 'default'
            ? alpha(theme.palette[color].main, 0.1)
            : theme.palette.action.disabledBackground,
        color:
          color !== 'default'
            ? theme.palette[color].main
            : theme.palette.text.primary,
        borderRadius: 2,
      })}
    />
  );
}
